import { useNavigate } from "react-router-dom";
import {useState} from 'react'
import Input from "../../components/ui/Input/Input";
import PassWordInput from '../../components/ui/Input/Password'

import Button from "../../components/ui/Button";
import { useAuth } from "../../context/AuthContext";
import CabecalhoForm from "../../components/ui/CabecalhoForm";
import EsqueciSenha from "../../components/Modais/EsqueciSenha";

import './Login.css'
export default function Login(){
    const [email, setEmail] = useState()
    const [password, setPassword] = useState()
    const {errorLogin, login} = useAuth()
    const [esqueciSenha, setEsqueciSenha] = useState(false)

    const navigate = useNavigate()

    const handleLogin = async() =>{
        const dadosUsuario = {
           email,
           password 
       }

       const primeiroLogin = await login(dadosUsuario);

       setTimeout(() => {
             if(primeiroLogin){
                 navigate('/apresentacao')
             }
             else{
                navigate('/inicial')
             }
        }, 100);

    }


    return <>
        <div className="containerLoginPage">
            <div className="areaForm">
                <div className="formLogin">
                    <CabecalhoForm textTyping="Semana da TI"/>
                        <Input
                                name="E-mail"
                                placeholder="Digite seu e-mail corporativo."
                                value={email}
                                onChange={(e)=> setEmail(e.target.value)}
                                type='text'
                                label="E-mail"
                            />
                            <PassWordInput
                                name="Senha"
                                value={password}
                                onChange={(e)=> setPassword(e.target.value)}
                                type='text'
                                label="Senha"
                            />
                            <span onClick={()=>setEsqueciSenha(true)} className="esqueciSenhaLink"> Esqueci minha senha</span>
                    <span className="erroMensagem">{errorLogin != null ? errorLogin : ""}</span>
                    
                    <Button text="Entrar" onClick={handleLogin} className="btnAmarelo" />
                    <div className="flex cadastro">
                        <p>Não possui cadastro?</p>
                        <Button text="Cadastre-se" onClick={()=> navigate('/cadastrar')} className="link" />
                    </div>
                </div>
            </div>
            
            <EsqueciSenha modalIsOpen={esqueciSenha} closeModal={()=>setEsqueciSenha(!esqueciSenha)} />
           
                
        </div>
    </>
}